








import { Component, Vue, Inject, Prop } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";

@Component({ components: {} })
export default class MyAppointment extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  list: Array<any> = [];
  async init() {
    this.list = [];
    this.list = await this.$store.dispatch({
      type: "appointment/getMyAppointment",
    });
  }
  visibleChange(value) {
    if (!value) {
      this.$emit("input", false);
    }
  }
  async cancel(item){
    await this.$store.dispatch({
      type: "appointment/cancelAppointment",
      data: { id: item.id }
    })
    this.init();
    this.$emit("cancel-event")
  }

  columns = [
    { title: this.L("MeetingTopic"), key: "topic" },
    {
      title: this.L("MeetingContent"),
      key: "content",
      render: (h, params) => {
        return h(
          "Tooltip",
          {
            props: {
              placement: "right",
              "max-width": 300,
            },
          },
          [
            params.row.content.length > 8
              ? params.row.content.substring(0, 8) + "..."
              : params.row.content,
            [h("p", { slot: "content" }, params.row.content)],
          ]
        );
      },
    },
    { title: this.L("AppointmentTime"), key: "time", width:155 },
    { title: this.L("Date"), key: "date" },
    {
      title: this.L("State"),
      render: (h: any, params: any) => {
        return h(
          "span",
          params.row.approveState == 0
            ? this.L("ON")
            : params.row.approveState == 1
            ? this.L("PASS")
            :params.row.approveState == 2
            ? this.L("FAIL")
            : this.L("CANCEL")
        );
      },
    },{
      title: this.L("Actions"),
      key: "Actions",
      render: (h: any, params: any) => {
        return h("div", [
          h(
            "Button",
            {
              props: {
                type: "primary",
                size: "small"
              },
              style: {
                marginRight: "5px",
                display:(params.row.approveState != 0)?"none":"inline-block"
              },
              on: {
                click: () => {
                  this.cancel(params.row);
                },
              },
            },
            this.L("Cancel")
          )
        ]);
      },
    },
  ];
}
